
// /*eslint-disable*/
import React, { useState, useEffect } from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
import { PropTypes } from "prop-types";

// reactstrap components
import {
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Media,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import adminlogo from "../../assets/img/icons/common/32_32.png";
import { SettingsIcon } from "components/Icons";

const routeColorMap = {
  "Dashboard": "text-danger",
  "Analytics & Growth": "text-purple",
  "Judges Dashboard": "text-primary",
  "Users": "text-info",
  "Rooms & Chats": "text-green",
  "Moderation": "text-warning",
  "Wallet & Payments": "text-yellow",
  "KYC & Disputes": "text-orange",
  "Reputation & Badges": "text-pink",
  "Community Features": "text-indigo",
  "Security Tools": "text-danger",
  "System Logs": "text-gray",
  "Role Management": "text-info",
  "Country & City": "text-info",
  "Reputation Config": "text-danger",
  "Privacy Policy": "text-info",
  "Terms & Conditions": "text-pink",
  "Contact Us": "text-red",
  "Room Types": "text-info",
  "Report Types": "text-danger",
  "Promotion Plan": "text-info",
  "Creator Management": "text-info",
  "Referral Management": "text-success",
  "Withdraw Fund Management": "text-success",
  "Profile": "text-yellow"
};

var ps;

const Sidebar = (props) => {
  const navigate = useNavigate();
  const [collapseOpen, setCollapseOpen] = useState();
  const [collapseState, setCollapseState] = useState("");
  const [isHovered, setIsHovered] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { isPinned, routes, logo } = props;
  const [userRole, setUserRole] = useState(localStorage.getItem("userRole") || "admin");
  const toggleSidebar = () => {
  setSidebarOpen((prev) => !prev);
};
  const [userPermissions, setUserPermissions] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("userPermissions") || "[]");
    } catch (e) {
      return [];
    }
  });

  useEffect(() => {
    const handleRoleUpdate = () => {
      setUserRole(localStorage.getItem("userRole") || "admin");
      try {
        setUserPermissions(JSON.parse(localStorage.getItem("userPermissions") || "[]"));
      } catch (e) { }
    };
    window.addEventListener("userRoleUpdated", handleRoleUpdate);
    return () => window.removeEventListener("userRoleUpdated", handleRoleUpdate);
  }, []);

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return props.location?.pathname?.indexOf(routeName) > -1 ? "active" : "";
  };
  // toggles collapse between opened and closed (true/false)
  const toggleCollapse = () => {
    setCollapseOpen((data) => !data);
  };
  // closes the collapse
  const closeCollapse = () => {
    setCollapseOpen(false);
  };


  // creates the links that appear in the left menu / Sidebar
  const createLinks = (routes) => {
    const isSidebarClosed =
      !isPinned && !isHovered;
    return routes.map((prop, key) => {
      const role = userRole?.toLowerCase();

      const isSuperAdmin = role === "super admin" || role === "admin";
      if (!isSuperAdmin) {
        const allowedRoutes = ["Profile"];
        if (role === "judge") {
          allowedRoutes.push("Judges Dashboard");
        }
        allowedRoutes.push(...userPermissions);

        if (prop.name && !allowedRoutes.includes(prop.name)) {
          return null;
        }
      }

      if (role !== "judge" && prop.role === "judge") return null;

      return (
        <NavItem key={key}>
          <NavLink
            to={prop.layout + prop.path}
            tag={NavLinkRRD}
            title={isSidebarClosed ? prop.name : ""}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: isSidebarClosed ? "center" : "flex-start",
              padding: "10px 15px"
            }}
          >
            {typeof prop.icon === "string" ? (
              <i
                className={prop.icon}
                title={prop.name}
                style={{
                  fontSize: "18px",
                  marginRight: isSidebarClosed ? "0px" : "10px"
                }}
              />
            ) : React.isValidElement(prop.icon) ? (
              React.cloneElement(prop.icon, {
                title: prop.name,
                className: `${prop.icon.props?.className || ""} ${routeColorMap[prop.name] || ""}`.trim(),
                style: {
                  width: "24px",
                  height: "24px",
                  marginRight: isSidebarClosed ? "0px" : "10px",
                  ...prop.icon.props?.style
                }
              })
            ) : prop.icon ? (
              <prop.icon
                title={prop.name}
                className={routeColorMap[prop.name] || ""}
                style={{
                  width: "24px",
                  height: "24px",
                  marginRight: isSidebarClosed ? "0px" : "10px"
                }}
              />
            ) : null}


            {!isSidebarClosed && <span>{prop.name}</span>}
          </NavLink>
        </NavItem>
      );
    });
  };


  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_blank",
    };
  }

  return (
    <Navbar
      className={`navbar-vertical fixed-left navbar-light bg-white px-4 !rounded-[7px] ${isPinned ? "sidebar-pinned" : ""
        } ${isHovered && !isPinned ? "sidebar-hovered" : ""}`}
      expand="md"
      id="sidenav-main"
    >
      <Container fluid className="justify-content-start gap-40 ">
        {/* Toggler */}
        <div className="w-100 d-flex justify-content-between align-items-center gap-2">

            <button type="button" onClick={toggleSidebar} className="navbar-toggler"> 
      <span className="navbar-toggler-icon" />
    </button>

        {/* Brand section - Dynamic toggle between Image (Full) and Text (Mini) */}
       <div
  className={`w-100 d-flex align-items-center brand-container ${
    (isPinned || isHovered)
      ? "justify-content-start"
      : "justify-content-center"
  }`}
>

          {(isPinned || isHovered) ? (
            <img
              src={require("../../assets/img/logo.png")}
              alt="CradleAI"
              title="CradleAI Dashboard"
              onClick={() => navigate("/admin/dashboard")}
              className="w-110 object-fit-cover"
            />
          ) : (
            <img
               src={require("../../assets/img/sidebar-logo.png")}
              alt="CradleAI"
              title="CradleAI Dashboard"
              onClick={() => navigate("/admin/dashboard")}
              className="w-34 h-34 cursor-pointer"
            />
          )}
        </div>
        {/* User */}
        <div className="d-flex align-items-center d-md-none">
          <UncontrolledDropdown nav>
            <DropdownToggle nav className="nav-link-icon">
              <i className="ni ni-bell-55" />
            </DropdownToggle>
            <DropdownMenu
              aria-labelledby="navbar-default_dropdown_1"
              className="dropdown-menu-arrow"
              right
            >
              <DropdownItem>Action</DropdownItem>
              <DropdownItem>Another action</DropdownItem>
              <DropdownItem divider />
              <DropdownItem>Something else here</DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
          <UncontrolledDropdown nav>
            <DropdownToggle nav>
              <Media className="align-items-center">
                <span className="avatar avatar-sm rounded-circle">
                  <img
                    alt="User avatar"
                    src={require("../../assets/img/theme/team-1-800x800.jpg")}
                  />
                </span>
              </Media>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-arrow" right>
              <DropdownItem className="noti-title" header tag="div">
                <h6 className="text-overflow m-0">Welcome!</h6>
              </DropdownItem>
              <DropdownItem to="/admin/profile" tag={Link}>
                <i className="ni ni-single-02" />
                <span>My profile</span>
              </DropdownItem>
              {/* <DropdownItem to="/admin/user-profile" tag={Link}>
                <i className="ni ni-settings-gear-65" />
                <span>Settings</span>
              </DropdownItem> */}
              <DropdownItem divider />
              <DropdownItem href="#pablo" onClick={(e) => e.preventDefault()}>
                <i className="ni ni-user-run" />
                <span>Logout</span>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
        </div>
        {/* Collapse */}
        
        <div class ="d-none d-md-block">
        
          {/* Collapse header */}
          <div className="navbar-collapse-header d-none">
            <Row>
              {/* Mobile brand section */}
              <Col className="collapse-brand" xs="6">
                <img
                  alt="CradleAI Logo"
                  src={require("../../assets/img/logo.png")}
                  style={{ height: "40px", width: "auto" }}
                />
              </Col>
              <Col className="collapse-close" xs="6">
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleCollapse}
                >
                  <span />
                  <span />
                </button>
              </Col>
            </Row>
          </div>
          {/* Form */}
          <Form className="mt-4 mb-3 d-none">
            <InputGroup className="input-group-rounded input-group-merge">
              <Input
                aria-label="Search"
                className="form-control-rounded form-control-prepended"
                placeholder="Search"
                type="search"
              />
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <span className="fa fa-search" />
                </InputGroupText>
              </InputGroupAddon>
            </InputGroup>
          </Form>
          {/* Navigation */}
          <Nav navbar >

            {/* 🔹 NORMAL ROUTES */}
            {createLinks(
              routes.filter(
                (route) =>
                  route.name &&
                  route.layout === "/admin" &&
                  ![
                    "Role Management",
                    "Country & City",
                    "Reputation Tiers",
                    "Room Types",
                    "Report Types",
                    "Promotion Plan",
                    "Creator Management",
                    "Referral Management",
                    "Privacy Policy",
                    "Terms & Conditions",
                    "Contact Us",
                    "Profile",
                    "Reputation Config",
                    "Analytics & Growth"
                  ].includes(route.name)
              )
            )}

            {/* 🔹 MANAGEMENT PARENT & CHILD */}
            {userRole?.toLowerCase() !== "judge" && (() => {
              const managementRoutes = [
                "Role Management",
                "Country & City",
                "Reputation Tiers",
                "Room Types",
                "Report Types",
                "Promotion Plan",
                "Creator Management",
                "Referral Management",
                "Privacy Policy",
                "Terms & Conditions",
                "Contact Us",
                "Reputation Config",
              ];

              const allowedManagementRoutes = routes.filter((route) => {
                if (!managementRoutes.includes(route.name)) return false;
                const role = userRole?.toLowerCase();
                const isSuperAdmin = role === "super admin" || role === "admin";
                if (!isSuperAdmin) {
                  return userPermissions.includes(route.name);
                }
                return true;
              });

              if (allowedManagementRoutes.length === 0) return null;

              return (
                <>
                  <NavItem>
                    <NavLink
                      href="#management"
                      onClick={(e) => {
                        e.preventDefault();
                        setCollapseState(
                          collapseState === "management" ? "" : "management"
                        );
                      }}
                      className={`nav-link ${collapseState === "management" ? "active" : ""}`}
                      style={{
                        display: "flex",
                        alignItems: "start",
                        justifyContent:
                          (!isPinned && !isHovered) ? "center" : "flex-start",
                        padding: "10px 15px"
                      }}
                    >
                      <SettingsIcon
                        style={{
                          width: "18px",
                          height: "18px",
                          marginRight:
                            (!isPinned && !isHovered) ? "0px" : "10px"
                        }}
                      />
                      {(isPinned || isHovered) && (
                        <span style={{ marginLeft: "10px" }}>
                          Management
                        </span>
                      )}
                    </NavLink>
                  </NavItem>

                  {/* 🔹 MANAGEMENT CHILD */}
                  {collapseState === "management" &&
                    allowedManagementRoutes.map((prop, key) => (
                      <NavItem key={key}>
                        <NavLink
                          to={prop.layout + prop.path}
                          tag={NavLinkRRD}
                          title={(!isPinned && !isHovered) ? prop.name : ""}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent:
                              (!isPinned && !isHovered)
                                ? "center"
                                : "flex-start",
                            padding: "10px 15px"
                          }}
                        >
                          {typeof prop.icon === "string" ? (
                            <i
                              className={prop.icon}
                              title={prop.name}
                              style={{
                                marginRight:
                                  (!isPinned && !isHovered)
                                    ? "0px"
                                    : "10px"
                              }}
                            />
                          ) : React.isValidElement(prop.icon) ? (
                            React.cloneElement(prop.icon, {
                              title: prop.name,
                              className: `${prop.icon.props?.className || ""} ${routeColorMap[prop.name] || ""}`.trim(),
                              style: {
                                width: "18px",
                                height: "18px",
                                marginRight:
                                  (!isPinned && !isHovered)
                                    ? "0px"
                                    : "10px",
                                ...prop.icon.props?.style
                              }
                            })
                          ) : prop.icon ? (
                            <prop.icon
                              title={prop.name}
                              className={routeColorMap[prop.name] || ""}
                              style={{
                                width: "18px",
                                height: "18px",
                                marginRight:
                                  (!isPinned && !isHovered)
                                    ? "0px"
                                    : "10px"
                              }}
                            />
                          ) : null}
                          {(isPinned || isHovered) && (
                            <span>{prop.name}</span>
                          )}
                        </NavLink>
                      </NavItem>
                    ))}
                </>
              );
            })()}
          </Nav>
          {/* Divider */}


        </div>

    {/* 🌑 OVERLAY SIDEBAR (MOBILE) */}
    <div
      className={`sidebar-overlay ${sidebarOpen ? "show" : ""}`}
      onClick={toggleSidebar}
    >
      <div
        className={`sidebar-panel ${sidebarOpen ? "open" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >

          {/* Form */}
          <Form className="mt-4 mb-3">
            <InputGroup className="input-group-rounded input-group-merge">
              <Input
                aria-label="Search"
                className="form-control-rounded form-control-prepended"
                placeholder="Search"
                type="search"
              />
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <span className="fa fa-search" />
                </InputGroupText>
              </InputGroupAddon>
            </InputGroup>
          </Form>
          {/* Navigation */}
          <Nav navbar className="h-87vh overflow-auto" >

            {/* 🔹 NORMAL ROUTES */}
            {createLinks(
              routes.filter(
                (route) =>
                  route.name &&
                  route.layout === "/admin" &&
                  ![
                    "Role Management",
                    "Country & City",
                    "Reputation Tiers",
                    "Room Types",
                    "Report Types",
                    "Promotion Plan",
                    "Creator Management",
                    "Referral Management",
                    "Privacy Policy",
                    "Terms & Conditions",
                    "Contact Us",
                    "Profile",
                    "Reputation Config",
                    "Analytics & Growth"
                  ].includes(route.name)
              )
            )}

            {/* 🔹 MANAGEMENT PARENT & CHILD */}
            {userRole?.toLowerCase() !== "judge" && (() => {
              const managementRoutes = [
                "Role Management",
                "Country & City",
                "Reputation Tiers",
                "Room Types",
                "Report Types",
                "Promotion Plan",
                "Creator Management",
                "Referral Management",
                "Privacy Policy",
                "Terms & Conditions",
                "Contact Us",
                "Reputation Config",
              ];

              const allowedManagementRoutes = routes.filter((route) => {
                if (!managementRoutes.includes(route.name)) return false;
                const role = userRole?.toLowerCase();
                const isSuperAdmin = role === "super admin" || role === "admin";
                if (!isSuperAdmin) {
                  return userPermissions.includes(route.name);
                }
                return true;
              });

              if (allowedManagementRoutes.length === 0) return null;

              return (
                <>
                  <NavItem>
                    <NavLink
                      href="#management"
                      onClick={(e) => {
                        e.preventDefault();
                        setCollapseState(
                          collapseState === "management" ? "" : "management"
                        );
                      }}
                      className={`nav-link ${collapseState === "management" ? "active" : ""}`}
                      style={{
                        display: "flex",
                        alignItems: "start",
                        justifyContent:
                          (!isPinned && !isHovered) ? "center" : "flex-start",
                        padding: "10px 15px"
                      }}
                      
                    >
                      <SettingsIcon
                        style={{
                          width: "18px",
                          height: "18px",
                          marginRight:
                            (!isPinned && !isHovered) ? "0px" : "10px"
                        }}
                      />
                      {(isPinned || isHovered) && (
                        <span style={{ marginLeft: "10px" }}>
                          Management
                        </span>
                      )}
                    </NavLink>
                  </NavItem>

                  {/* 🔹 MANAGEMENT CHILD */}
                  {collapseState === "management" &&
                    allowedManagementRoutes.map((prop, key) => (
                      <NavItem key={key}>
                        <NavLink
                          to={prop.layout + prop.path}
                          tag={NavLinkRRD}
                          title={(!isPinned && !isHovered) ? prop.name : ""}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent:
                              (!isPinned && !isHovered)
                                ? "center"
                                : "flex-start",
                            padding: "10px 15px"
                          }}
                        >
                          {typeof prop.icon === "string" ? (
                            <i
                              className={prop.icon}
                              title={prop.name}
                              style={{
                                marginRight:
                                  (!isPinned && !isHovered)
                                    ? "0px"
                                    : "10px"
                              }}
                            />
                          ) : React.isValidElement(prop.icon) ? (
                            React.cloneElement(prop.icon, {
                              title: prop.name,
                              className: `${prop.icon.props?.className || ""} ${routeColorMap[prop.name] || ""}`.trim(),
                              style: {
                                width: "18px",
                                height: "18px",
                                marginRight:
                                  (!isPinned && !isHovered)
                                    ? "0px"
                                    : "10px",
                                ...prop.icon.props?.style
                              }
                            })
                          ) : prop.icon ? (
                            <prop.icon
                              title={prop.name}
                              className={routeColorMap[prop.name] || ""}
                              style={{
                                width: "18px",
                                height: "18px",
                                marginRight:
                                  (!isPinned && !isHovered)
                                    ? "0px"
                                    : "10px"
                              }}
                            />
                          ) : null}
                          {(isPinned || isHovered) && (
                            <span>{prop.name}</span>
                          )}
                        </NavLink>
                      </NavItem>
                    ))}
                </>
              );
            })()}
          </Nav>
</div>
</div>
        
      </Container>
    </Navbar>
  );
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired,
  }),
};
export default Sidebar;





